export const messagesAdmPartners = {
    pt: {
        message:{
            confirmPartnerDeactivation: "Confirma desativação do parceiro?",
            deactivatePartner: "Desativar parceiro?",
            registerPartner: "Cadastrar parceiro",
            deactivatePartnerAlert: ` <b>Atenção:</b>
                <span
                    >Ao desativar este parceiro, todos os estabelecimentos
                    vinculados a ele também ficarão desativados.</span
                >`

        }
    },
    es: {
        message:{
            confirmPartnerDeactivation:"¿Confirma la desactivación del compañero?",
            deactivatePartner:"¿Deshabilitar socio?",
            registerPartner:"Registro Socio",
            deactivatePartnerAlert: ` <b>Atención:</b>
                <span
                    >Al desactivar este socio, todos los establecimientos
                    Los términos garantizados para él también serán deshabilitados.</span
                >`
        }
    },
    en: {
        message:{
            confirmPartnerDeactivation: "Confirm partner deactivation?",
            deactivatePartner: "Deactivate partner?",
            registerPartner: "Register partner",
            deactivatePartnerAlert: ` <b>Attention::</b>
                <span
                    >By deactivating this partner, all establishments
terms granted to him/her will also be deactivated.</span
                >`
        }
    }
}
